import { Injectable } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

import { AccountEditDrawerComponent } from '@main-client/src/app/account-edit-drawer/account-edit-drawer.component';

import { Account } from '@libs/src/models/account.model';
import { Group } from '@libs/src/models/group.model';

@Injectable()
export class AccountEditDrawerService {
  constructor(public drawer: NzDrawerService) {}

  openDrawer(
    account: Account,
    group: Group,
    onUpdate?: (updatedAccount: Account) => any,
  ) {
    return this.drawer.create({
      nzContent: AccountEditDrawerComponent,
      nzData: { account, group, onUpdate },
      nzWidth: '600px',
    });
  }
}
